// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1_Th3","insightsList":"newBusinessInsightsMenu_insightsList__2bExG","active":"newBusinessInsightsMenu_active__2HX8H"};